import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'
import requestAddDocumentToCard from './requestAddDocumentToCard'
import requestAddDocumentToDocumentList from './requestAddDocumentToDocumentList'
import {
  add as addToast,
  set as setToast,
  remove as removeToast
} from 'store/redux/toasts'

type Payload = {
  boardId: number;
  documentSourceId?: number;
  cardId?: number;
  documentListId?: number
  url: string
  templateSourceId?: number
  templateIdentifier: string
}

const requestAddDocumentFromTemplate = (payload: Payload) => async (dispatch, getState) => {
  const { boardId, documentSourceId, cardId, documentListId, url, templateSourceId, templateIdentifier } = payload

  const state = getState()

  const args: any = {
    boardId,
    url,
    templateSourceId,
    templateIdentifier,
  }

  if (documentSourceId) {
    args.documentSourceId = documentSourceId
  }

  const toastId = `add-new-document-${Date.now()}`

  dispatch(addToast({
    id: toastId,
    message: state.kanbo.locale.messages['DOCUMENT_ADD_FROM_TEMPLATE_PROGRESS_RUNNING'],
    progress: 10,
  }))

  try {
    const { DocumentSourceId, Url } = await apiAction('AddNewDocument', args)

    dispatch(setToast({
      id: toastId,
      progress: 70
    }))

    if (documentListId) {
      await dispatch(requestAddDocumentToDocumentList({
        documentListId,
        url: Url,
        documentSourceId: DocumentSourceId,
      }))
    } else if (cardId) {
      await dispatch(requestAddDocumentToCard({
        cardId,
        url: Url,
        documentSourceId: DocumentSourceId,
      })) 
    }

    dispatch(setToast({
      id: toastId,
      message: state.kanbo.locale.messages['DOCUMENT_ADD_FROM_TEMPLATE_PROGRESS_COMPLETED'],
      type: 'success',
      progress: 100
    }))
  } catch (error) {
    dispatch(setToast({
      id: toastId,
      type: 'danger',
      progress: false
    }))

    if (error.code === 509) {
      const state = getState()

      sweetalert({
        type: 'info',
        text: state.kanbo.locale.messages['UPLOAD_FILE_EXISTS'].replace('{fileName}', url),
      })
    }
  } finally {
    setTimeout(() => {
      dispatch(removeToast({
        id: toastId
      }))
    }, 2000)
  }
}

export default requestAddDocumentFromTemplate
